/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Autocomplete, Box, Button, ListItem, MenuItem, TextField } from "@mui/material";
import { getAllWorkerIdentificationTypes, GetAllWorkRole, searchWorkers } from "../../../api/apiCall";
import { useAuth } from "../../../auth/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const StaffDetails = () => {
  const { state } = useAuth();
  const navigate = useNavigate();
  const [workers, setWorkers] = useState<any>([]);
  const [identifications, setIdentifications] = useState<any>([]);
  const [workRoles, setWorkRoles] = useState<any>([]);

  const {register, handleSubmit, watch, control} = useForm<any>({
    defaultValues: {
      name: "",
      pts: "",
      phoneNumber: "",
      notes: "",
      pageNumber: 0,
      identificationTypeId: null,
      roleId: null,
    }
  })

  const watchFields = watch();

  const getWorkers = async (data: any) => {
    data.roleId = data.roleId?.id || null;
    const response: any = await searchWorkers(state.user?.token, data);
    setWorkers(response)
  }

  const getAllIdentifications = async () => {
    const response = await getAllWorkerIdentificationTypes(state.user?.token);
    setIdentifications(response.data);
   }

  const handleClick = (userId: any) => {
    const url = `/pace-team/resourcing/profile?workerId=${userId}`;
    window.open(url, '_blank');
  };

  const handleCreateWorker = () => {
    navigate('/pace-team/resourcing/create-worker');
  };

  const columns: any = [
    {
      field: "name",
      headerName: "Full Name",
      flex: 1.3,
      renderCell: (params: any) => (
        <div
          onClick={() => handleClick(params.row.id)}
          style={{cursor: "pointer"}}
        >
          {params.row.name} {params.row.surname}
        </div>
      ),
    },
    {
      field: "username",
      headerName: "Username",
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: "pts",
      headerName: "PTS/CSCS/CPCS",
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        const pts = params.row?.pts;
        const ids = params.row?.identifications || [];

        return (
          <div style={{ display: "flex", flexDirection: "column", textAlign: 'start', lineHeight: ids.length >= 1 ? 1.2 : 'revert-layer' }}>
            {pts && <span>PTS: {pts}</span>}
            {ids.map((i: any) => (
              <span key={i.id}>
                {i.identificationType?.name}: {i.number}
              </span>
            ))}
          </div>
        );
      }
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1.3,
    },
    {
      field: "workRoles",
      headerName: "Work Roles",
      flex: 1.2,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        const roles = params.row?.workRoles || [];

        return (
          <div style={{ display: "flex", flexDirection: "column", textAlign: 'center', lineHeight: roles.length > 1 ? 1.2 : 'revert-layer' }}>
            {roles.map((r: any) => (
              <span key={r}>
                {r}
              </span>
            ))}
          </div>
        );
      }
    },
    {
      field: "verified",
      headerName: "Verified",
      flex: 0.7,
      headerAlign: "center",
      align: 'center',
      renderCell: (params: any) => (
        <div>
          {params.row.verified?
            (<FontAwesomeIcon icon={faCheck} size={'lg'} color={'green'} />)
            : (<FontAwesomeIcon icon={faX} size={'lg'} color={'red'} />)}
        </div>
      ),
    },
    {
      field: "postCode",
      headerName: "Post Code",
      flex: 1,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => (
        <Button
          variant="contained"
          onClick={() => handleClick(params.row.id)}
          style={{
            boxShadow: 'none',
            backgroundColor: '#6c757d'
          }}
        >
          Details
        </Button>
      )
    }
  ];

  useEffect(() => {
    setTimeout(() => {
      getWorkers(watchFields)
    }, 500)

    getAllIdentifications()
  }, [watchFields.name, watchFields.pts, watchFields.phoneNumber, watchFields.identificationTypeId, watchFields.roleId])

  useEffect(() => {
    GetAllWorkRole(state.user?.token).then(setWorkRoles);
    getWorkers({});
  }, []);

  return (
    <>
      <div className="form-content">
        <TextField
          label="Full Name"
          type="text"
          size="small"
          {...register("name")}
          style={{width: "15%", margin: 10}} />
        <TextField
          label="PTS"
          type="text"
          size="small"
          {...register("pts")}
          style={{width: "15%", margin: 10}} />
        <TextField
          label="Phone Number"
          id="outlined-basic"
          variant="outlined"
          type="text"
          {...register("phoneNumber")}
          size="small"
          style={{margin: 10, width: "15%"}} />
        <TextField
          select
          label="Type"
          fullWidth
          size="small"
          defaultValue={null}
          style={{margin: 10, width: "13%"}}
          {...register(`identificationTypeId`)}
        >
          {identifications.map((item: any) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
        </TextField>
        <Controller
        name="roleId"
        control={control}
        render={({ field }) => (
          <Autocomplete
            {...field}
            size="small"
            options={workRoles}
            style={{ margin: 10, width: "13%" }}
            getOptionLabel={(option: any) => option?.workRoleName || ""}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            onChange={(_, newValue) => field.onChange(newValue)}
            value={field.value || null}
            renderOption={(props, option) => (
              <ListItem {...props} key={option.workRoleName}>
                {option.workRoleName}
              </ListItem>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Work Role"
                placeholder="Select Work Role"
              />
            )}
          />
        )}
      />
        {/* <TextField
          label="Notes"
          id="outlined-basic"
          variant="outlined"
          type="text"
          {...register("notes")}
          size="small"
          style={{margin: 10, width: "15%"}} /> */}
        {/* <Button
          variant="contained"
          onClick={handleSubmit(getWorkers)}
          style={{height: 40, margin: 10, boxShadow: 'none', width: "10%"}}>
          Filter
        </Button> */}
        <Button
          variant="contained"
          onClick={handleCreateWorker}
          style={{height: 40, margin:10, boxShadow: 'none', width: "14.6%"}}>
          Create New Worker
        </Button>
      </div>
      <Box sx={{height: "800px", width: "95%", margin: '0 auto'}} mt={3}>
        <DataGrid
          rows={workers || []}
          columns={columns}
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 100,
              },
            },
          }}
          pageSizeOptions={[100]}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              fontSize: 15
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: '#f0f0f0',
              color: "#000",
              fontWeight: "bold",
            },
            '& .disable-columns': {
              borderRight: '1px solid #bfbfbf'
            },
            '& .border-left': {
              borderLeft: '1px solid #bfbfbf',
            },
          }}
        />
      </Box>
    </>
  );
};

export default StaffDetails;
